import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import vendorStaffService from '../api/vendorStaffService';
import adminStaffService from '../api/adminStaffService';

// --- Vendor Staff Hooks ---
export const useVendorStaff = (params) => {
    return useQuery({
        queryKey: ['vendorStaff', params],
        queryFn: () => vendorStaffService.getStaff(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000
    });
};

export const useCreateStaff = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: vendorStaffService.createStaff,
        onSuccess: () => {
            queryClient.invalidateQueries(['vendorStaff']);
        }
    });
};

export const useUpdateStaff = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => vendorStaffService.updateStaff(id, payload),
        onSuccess: () => {
            queryClient.invalidateQueries(['vendorStaff']);
        }
    });
};

export const useDeleteStaff = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: vendorStaffService.deleteStaff,
        onSuccess: () => {
            queryClient.invalidateQueries(['vendorStaff']);
        }
    });
};

// --- Admin Oversight Hooks (Vendor Staff) ---
export const useAdminAllVendorStaff = (params) => {
    return useQuery({
        queryKey: ['adminAllVendorStaff', params],
        queryFn: () => adminStaffService.getAllVendorStaff(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000
    });
};

export const useUpdateVendorStaffStatus = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, status }) => adminStaffService.updateVendorStaffStatus(id, status),
        onSuccess: () => {
            queryClient.invalidateQueries(['adminAllVendorStaff']);
        }
    });
};

export const useAdminUpdateVendorStaff = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => adminStaffService.updateVendorStaff(id, payload),
        onSuccess: () => {
            queryClient.invalidateQueries(['adminAllVendorStaff']);
        }
    });
};

export const useAdminDeleteVendorStaff = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: adminStaffService.deleteVendorStaff,
        onSuccess: () => {
            queryClient.invalidateQueries(['adminAllVendorStaff']);
        }
    });
};

// --- Platform Employee Hooks (Internal Admins) ---
export const useAllAdmins = (params) => {
    return useQuery({
        queryKey: ['allAdmins', params],
        queryFn: () => adminStaffService.getAllAdmins(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000
    });
};

export const useCreateAdmin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: adminStaffService.createAdmin,
        onSuccess: () => {
            queryClient.invalidateQueries(['allAdmins']);
        }
    });
};

export const useUpdateAdmin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => adminStaffService.updateAdmin(id, payload),
        onSuccess: () => {
            queryClient.invalidateQueries(['allAdmins']);
        }
    });
};

export const useDeleteAdmin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: adminStaffService.deleteAdmin,
        onSuccess: () => {
            queryClient.invalidateQueries(['allAdmins']);
        }
    });
};
